import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, Circle, ArrowRight } from "lucide-react";
import { driverApi } from "../../lib/api";

// Shows a driver what's still missing before they can accept rides/deliveries.
// Auto-hides once the profile is complete and KYC is approved.
export default function DriverReadinessBanner({ showLink = false, to = "/app/profile" }) {
  const [data, setData] = useState(null);
  useEffect(() => { driverApi.readiness().then(setData).catch(() => setData(null)); }, []);
  if (!data || data.complete) return null;
  return (
    <div className="mb-6 rounded-2xl border border-amber-300 bg-amber-50 p-4" data-testid="driver-readiness-banner">
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900"><AlertTriangle className="h-4 w-4 text-amber-600" /> Finish your profile to start accepting work</p>
      <p className="mt-1 text-xs text-amber-800">{data.reason}</p>
      <ul className="mt-3 space-y-1">
        {(data.items || []).map((it) => (
          <li key={it.key} className="flex items-center gap-2 text-sm" data-testid={`readiness-${it.key}`}>
            {it.done ? <CheckCircle2 className="h-4 w-4 text-green-600" /> : <Circle className="h-4 w-4 text-amber-500" />}
            <span className={it.done ? "text-ink-soft line-through" : "font-medium text-ink"}>{it.label}</span>
          </li>
        ))}
      </ul>
      {showLink && (
        <Link to={to} className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-amber-800 hover:underline" data-testid="readiness-complete-link">Complete your profile <ArrowRight className="h-4 w-4" /></Link>
      )}
    </div>
  );
}
